// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"a2d0524f","453":"6a64aa0b","732":"66b31e37","977":"1ca6c5c8"}[chunkId] + ".chunk.js";
};